
import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';

interface Team {
  name: string;
  clubs?: {
    id: string;
    name: string;
    organizations?: {
      id: string;
      name: string;
    } | null;
  } | null;
}

interface TeamBreadcrumbProps {
  team: Team;
}

export const TeamBreadcrumb = ({ team }: TeamBreadcrumbProps) => {
  return (
    <div className="flex items-center gap-2 mb-6 text-sm text-muted-foreground">
      <Link to="/superadmin" className="hover:text-foreground">
        Super Admin
      </Link>
      <ChevronRight className="h-4 w-4" />
      {team.clubs?.organizations && (
        <>
          <Link 
            to={`/superadmin/org/${team.clubs.organizations.id}`}
            className="hover:text-foreground"
          >
            {team.clubs.organizations.name}
          </Link>
          <ChevronRight className="h-4 w-4" />
        </>
      )}
      {team.clubs && (
        <>
          <Link 
            to={`/superadmin/club/${team.clubs.id}`}
            className="hover:text-foreground"
          >
            {team.clubs.name}
          </Link>
          <ChevronRight className="h-4 w-4" />
        </>
      )}
      <span className="text-foreground">{team.name}</span>
    </div>
  );
};
